// Copying text out of the app, in whatever the WebView will allow.
//
// Lifted out of the ticket screen the day Today grew a Copy legs button of its
// own. The fallback is the reason this is worth a file: an old Android WebView
// either has no Clipboard API or refuses it, and the textarea trick that still
// works there has to run inside the tap — so it cannot be hidden behind
// anything that awaits first.

/**
 * What to say when both paths fail. The legs are selectable text on both
 * screens that copy, so the advice is the same in both places: take them by
 * hand.
 */
export const COPY_FAILED = 'Couldn’t copy. Long-press the legs to copy them.';

// A hidden textarea and `execCommand`. Focus is put back where it was, because
// the caller's button is usually still on screen and still the thing the
// person is looking at.
function copyWithTextarea(text) {
  const back = document.activeElement;
  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.setAttribute('aria-hidden', 'true');
  Object.assign(area.style, { position: 'fixed', top: '0', left: '0', opacity: '0', fontSize: '1rem' });
  document.body.appendChild(area);
  area.select();
  area.setSelectionRange(0, text.length);
  let ok = false;
  try { ok = document.execCommand('copy'); } catch { ok = false; }
  area.remove();
  back?.focus?.();
  return ok;
}

/**
 * Put `text` on the clipboard, or throw a sentence a caller can print beside
 * its own button. Throwing rather than answering false is deliberate:
 * `useAction` turns a thrown message into the error line next to the control.
 */
export async function copyText(text) {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch { /* refused: fall through to the textarea */ }
  }
  if (!copyWithTextarea(text)) throw new Error(COPY_FAILED);
}
